import React from 'react';
import styles from './collapse-button.module.scss';
import {IconButton, Tooltip} from '@mui/material';
import {SVGS} from '../../../assets/images';
import classNames from 'classnames';

interface Props {
    isExpanded: boolean;
    onExpandClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
    tooltip?: string;
    displayText?: string;
    className?: string;
    containerClassName?: string;
    displayTextClassName?: string;
}

export const CollapseButton = (props: Props) => {
    return (<Tooltip title={props.tooltip}>
        <div className={classNames(
            styles.wrapper,
            props.containerClassName,
            { [styles.withLabel]: !!props.displayText }
        )}>
            <IconButton onClick={(event) => props.onExpandClick(event)} className={classNames({
                [styles.collapseButton]: true,
                [styles.active]: props.isExpanded
            }, props.className)}>
                <SVGS.RightChevronIcon className={styles.icon} />
            </IconButton>
            {props.displayText && (
                <span className={classNames(styles.displayText, props.displayTextClassName)}>
                    {props.displayText}
                </span>
            )}
        </div>       
    </Tooltip>);
};
